var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotAuthUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M6.247,15.915v4.489c0,0,4.324-1.795,8.156-1.795c3.833,0,8.156,1.795,8.156,1.795V15.85             c0,0-4.123-2.171-8.22-2.171C10.244,13.677,6.247,15.915,6.247,15.915z M27.137,14.843l1.621-0.867l-1.621-0.896v-0.426             c0,0,0.455-2.306-2.139-1.1c-0.131,0.071-0.203,0.145-0.232,0.215L14.063,5.855L0,13.876l5.313,2.403v-0.78             c0,0,4.453-2.492,9.021-2.492c4.568,0,9.162,2.424,9.162,2.424v1.361l2.932-1.568v6.354h-0.973v2.258l1.295-0.895l1.443,0.895             v-2.258h-1.057V14.843L27.137,14.843z M26.428,12.264v0.426l-0.855-0.473C25.883,12.01,26.428,11.725,26.428,12.264z             M26.141,14.757c-0.379,0-0.686-0.304-0.686-0.684c0-0.377,0.307-0.683,0.686-0.683c0.377,0,0.687,0.306,0.687,0.683             C26.826,14.453,26.518,14.757,26.141,14.757z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAuthUser);
export default __webpack_public_path__ + "static/media/notAuthUser.85351a06916f565ef73d7e51bc6e247b.svg";
export { ForwardRef as ReactComponent };